import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { DataSource, Repository } from "typeorm";
import { EmployyeHodMapping } from "./employee-mapping-entity";
import { CommonResponseModel } from "@project-management-system/shared-models";

@Injectable()
export class EmployeeHodMappingService {
    constructor(
        @InjectRepository(EmployyeHodMapping)

        private repo : Repository<EmployyeHodMapping>,
        private readonly dataSource: DataSource,

    ) {}

    
   

    async getEmployeeHod(): Promise<CommonResponseModel> {
        let query = `
            SELECT 
                emp.id,
                emp.employee_id,
                emp.hod_id,
                e1.employee_name AS employeeName,  
                e2.employee_name AS hodName        
            FROM 
                employee_hod_mapping emp
            LEFT JOIN 
                employee e1 ON e1.id = emp.employee_id  
            LEFT JOIN 
                employee e2 ON e2.id = emp.hod_id     
        `;
        const data = await this.dataSource.query(query);
        if (data) {
            return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", data);
        }
    }
    

}